import { SchemaHtmlThumbnailService } from './service';

export const generateThumbnail = async (html: string) => {
  try {
    const { thumbnail } = await SchemaHtmlThumbnailService.GenerateThumbnail({
      html,
    });
    return thumbnail ? `data:image/png;base64,${thumbnail}` : null;
  } catch (error) {
    console.error('Error generating email campaign thumbnail', error);
    return null;
  }
};
